<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-mloe-' + childId"
    data-toggle='collapse'
    :data-target="'#collapse-mloe-' + childId"
    :aria-controls="'collapse-mloe-' + childId"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ leagueName.trim() }}
  .collapse.show(
    :aria-labelledby="'heading-mloe-' + childId"
    :id="'collapse-mloe-' + childId"
  )
    .card-body.p-0
      .market-card-content
        .two-column
          .two-column-title {{ $t("ui.full_time") }}
          .two-column-content
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Home") }}
                  p.mb-0 {{ $t("m.ODD_Away") }}
                .two-column-odd-area-group
                  template(v-if="source['ml'] && source['ml'][0] && source['ml'][0][5] != 0 && source['ml'][0][5] != ''")
                    OddsItem(:odds="source['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
                  template(v-if="source['ml'] && source['ml'][0] && source['ml'][0][7] != 0 && source['ml'][0][7] != ''")
                    OddsItem(:odds="source['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Odd") }}
                  p.mb-0 {{ $t("m.ODD_Even") }}
                .two-column-odd-area-group
                  template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][5] != 0 && source['oe'][0][5] != ''")
                    OddsItem(:odds="source['oe'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
                  template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][7] != 0 && source['oe'][0][7] != ''")
                    OddsItem(:odds="source['oe'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    },
    childId: {
      type: Number
    }
  },
  computed: {
    leagueName() {
      var result = this.source["league"].split(" - ");
      if (result.length >= 2) {
        if (result.length - 2 != 0) {
          if (result.length <= 5) {
            return result[result.length - 2] + " - " + result[result.length - 1];
          }
          if (result.length <= 6) {
            return result[result.length - 3] + " - " + result[result.length - 2] + " - " + result[result.length - 1];
          }
        }
        return result[result.length - 1];
      }
      return this.source["league"];
    }
  }
}
</script>